export default ["N", "NE", "E", "SE", "S", "SW", "W", "NW", "C"];



// WEBPACK FOOTER //
// ./js/components/SFImage/anchorPoints.js